import React, { useEffect, useState } from "react";
import { api } from "../../app/Api/ApiSlice";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import moment from "moment";

const StoreInvoices = () => {
    const [userInvoices, setUserInvoices] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const { name } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const getInvoices = async () => {
            try {
                setIsLoading(true);
                const response = await api.get(`/stores/${name}/invoices`);
                setUserInvoices(response.data || []);
            } catch (error) {
                toast.error(error.response?.data?.message || "Error fetching invoices");
            } finally {
                setIsLoading(false);
            }
        };

        getInvoices();
    }, [name]);

    return (
        <div className="store-user-carts-list">
            <h5>My invoices in {name}</h5>

            {!isLoading && userInvoices.length === 0 && (
                <p className="not-found-msg">
                    You have not received any invoice in this store
                </p>
            )}

            {!isLoading && userInvoices.length > 0 && (
                <table>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>invoice No</th>
                            <th>Description</th>
                            <th>Items</th>
                            <th>Total Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        {userInvoices.map(invoice => (
                            <tr
                                key={invoice._id}
                                onClick={() => navigate(`/b/${name}/invoices/${invoice._id}`)}
                                style={{ cursor: "pointer" }}
                            >
                                <td>{moment(invoice.createdAt).format("DD/MM/YYYY")}</td>
                                <td>{invoice.invoiceNo}</td>
                                <td>{invoice.description || "No description"}</td>
                                <td>{invoice.items.length}</td>
                                <td>{invoice.total}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
              {isLoading && <Loader />}
        </div>
    );
};

export default StoreInvoices;
